import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M13.0667 3.68951C13.5078 2.80728 14.4095 2.25 15.3959 2.25C16.8341 2.25 18 3.4159 18 4.8541V5C18 5.64432 17.8125 6.24485 17.4891 6.75H17.5C19.5711 6.75 21.25 8.42893 21.25 10.5V17.5C21.25 19.5711 19.5711 21.25 17.5 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V10.5C2.75 8.42893 4.42893 6.75 6.5 6.75H6.51091C6.1875 6.24485 6 5.64432 6 5V4.8541C6 3.4159 7.1659 2.25 8.6041 2.25C9.59046 2.25 10.4922 2.80728 10.9333 3.68951L12 5.82295L13.0667 3.68951ZM13.2135 8.25H12H10.7865H10.25V11.75H19.75V10.5C19.75 9.25736 18.7426 8.25 17.5 8.25H14.75H13.2135ZM19.75 13.25H10.25V19.75H17.5C18.7426 19.75 19.75 18.7426 19.75 17.5V13.25ZM8.75 11.75V8.25H6.5C5.25736 8.25 4.25 9.25736 4.25 10.5V11.75H8.75ZM4.25 13.25H8.75V19.75H6.5C5.25736 19.75 4.25 18.7426 4.25 17.5V13.25ZM10.7865 6.75L9.59164 4.36033C9.40461 3.98628 9.02231 3.75 8.6041 3.75C7.99432 3.75 7.5 4.24432 7.5 4.8541V5C7.5 5.9665 8.2835 6.75 9.25 6.75H10.7865ZM16.5 5C16.5 5.9665 15.7165 6.75 14.75 6.75H13.2135L14.4084 4.36033C14.5954 3.98628 14.9777 3.75 15.3959 3.75C16.0057 3.75 16.5 4.24432 16.5 4.8541V5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
